import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';

const endpoint = settings.api_host + "/user/password/reset";

const apiResetPassword = async (email, password, fhash) => {
	if (!email) {
		throw new Error("Missing email");
	}
	if (!password) {
		throw new Error("Missing password");
	}
	if (!fhash) {
		throw new Error("Missing fhash");
	}
	try {
		// const response = await axios.post(endpoint, {
		// 	params: {
		// 		email
		// 	}
		// });

		var form = new FormData();
		form.append('email', email);
		form.append('password', password);
		form.append('fhash', fhash);

		const response = await axios({
			method: 'post',
			url: endpoint,
			data: form,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export default apiResetPassword;


// WEBPACK FOOTER //
// ./src/api/resetPassword.js